import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const ConversionRateChart = ({ data, loading }) => {
  const { t, currentLanguage } = useLanguage();

  const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-warm-md">
          <p className="text-sm font-medium text-foreground mb-1">
            {payload?.[0]?.payload?.stage}
          </p>
          <p className="text-sm text-primary font-semibold data-text">
            {payload?.[0]?.value}%
          </p>
        </div>
      );
    }
    return null;
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg p-4 md:p-6 shadow-warm border border-border animate-pulse">
        <div className="h-6 bg-muted rounded w-48 mb-6"></div>
        <div className="h-80 bg-muted rounded"></div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg p-3 sm:p-4 md:p-6 shadow-warm border border-border">
      <h3 className="text-base sm:text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6">
        {t('analytics.conversionFunnel')}
      </h3>
      <div className="w-full h-64 sm:h-72 md:h-80" aria-label={t('analytics.conversionFunnel')}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="stage" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '10px' }}
              angle={-20}
              textAnchor="end"
              height={70}
              interval={0}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              tickFormatter={(value) => `${value}%`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar 
              dataKey="rate" 
              radius={[8, 8, 0, 0]}
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ConversionRateChart;